import React from "react"
import { Link } from "gatsby";
export default function Certifications() {
    return (
        <section className="mb-3 position-relative bg-dark-gray section-dark py-3">
            <div className="cover-background position-absolute h-100 w-100 left-0px top-0px" style={{backgroundImage: 'url("../images/agency-bg-map.png")'}} />
            <div className="container position-relative">
                <div
                    className="row row-cols-1 row-cols-lg-5 row-cols-md-3 row-cols-sm-2 clients-style-06 justify-content-center gap-3"
                    data-anime="{ &quot;el&quot;: &quot;childs&quot;, &quot;translateY&quot;: [0, 0], &quot;scale&quot;: [1.1, 1], &quot;opacity&quot;: [0,1], &quot;duration&quot;: 800, &quot;delay&quot;: 200, &quot;staggervalue&quot;: 300, &quot;easing&quot;: &quot;easeOutQuad&quot; }">
                    <div className="col client-box text-center">
                        <Link to="/cloud-support">
                            <img
                                src="../images/certificate/AWS_architect.png"
                                className="h-150px"
                                alt="matrixbrains pvt ltd clients khissu news app"
                                loading="lazy"
                            />
                        </Link>
                    </div>
                    <div className="col client-box text-center">
                        <Link to="/cloud-support">
                            <img
                                src="../images/certificate/AWS_developer.png"
                                className="h-150px"
                                alt="matrixbrains pvt ltd clients ectl enhance communication"
                                loading="lazy"
                            />
                        </Link>
                    </div>
                    <div className="col client-box text-center">
                        <Link to="/cloud-support">
                            <img
                                src="../images/certificate/AWS_sysops.png"
                                className="h-150px"
                                alt="matrixbrains pvt ltd clients khissu news app"
                                loading="lazy"
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
